module.exports = "<div class=\"sk-folding-cube mb-5\">\n    <div class=\"sk-cube1 sk-cube\"></div>\n    <div class=\"sk-cube2 sk-cube\"></div>\n    <div class=\"sk-cube4 sk-cube\"></div>\n    <div class=\"sk-cube3 sk-cube\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/loading/loading.component.html
// module id = 494
// module chunks = 0